import {
  TYCOON_GROUP_COLORS,
  TYCOON_PASS_START_BONUS
} from '../../../tycoon-engine.js';

export function tycoonGridPosition(index) {
  if (index <= 10) return { row: 11, col: 11 - index };
  if (index <= 20) return { row: 21 - index, col: 1 };
  if (index <= 30) return { row: 1, col: index - 19 };
  return { row: index - 29, col: 11 };
}

export function formatTycoonMoney(value) {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    maximumFractionDigits: 0
  }).format(Math.max(0, Number(value) || 0));
}

export function tycoonTileIcon(tile) {
  if (tile.icon) return tile.icon;
  if (tile.type === 'railroad') return '🚂';
  if (tile.type === 'utility') return '⚙';
  // Property color bands already identify land tiles. Omitting the decorative
  // dot gives long Vietnamese place names another readable line.
  if (tile.type === 'property') return '';
  return '';
}

export function formatTycoonBoardMoney(value) {
  const amount = Math.max(0, Number(value) || 0);
  if (amount >= 1_000_000) {
    const millions = amount / 1_000_000;
    return `${new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 1 }).format(millions)}tr ₫`;
  }
  if (amount >= 1_000) {
    return `${new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 0 }).format(amount / 1_000)}k ₫`;
  }
  return formatTycoonMoney(amount);
}

export function tycoonTileMeta(tile, index, game) {
  if (tile.type === 'property') {
    const asset = game?.propertyState(index);
    if (asset?.mortgaged) return 'THẾ CHẤP';
    if (asset?.houses === 5) return '🏨 Khách sạn';
    if (asset?.houses > 0) return `🏠 ×${asset.houses}`;
    return formatTycoonBoardMoney(tile.price);
  }

  if (tile.type === 'railroad' || tile.type === 'utility') {
    const asset = game?.propertyState(index);
    return asset?.mortgaged ? 'THẾ CHẤP' : formatTycoonBoardMoney(tile.price);
  }

  if (tile.type === 'tax') return 'TRẢ ' + formatTycoonBoardMoney(tile.amount);
  if (tile.type === 'chance' || tile.type === 'community') return 'Rút thẻ';
  if (tile.type === 'start') return 'NHẬN ' + formatTycoonBoardMoney(TYCOON_PASS_START_BONUS);
  if (tile.type === 'goto-jail') return 'ĐI THẲNG';
  if (tile.type === 'jail') return 'ĐẾN THĂM';
  return '';
}

export { TYCOON_GROUP_COLORS };
